import { render, staticRenderFns } from "./OrganizationChartLevelForm.vue?vue&type=template&id=063d0df8&"
import script from "./OrganizationChartLevelForm.vue?vue&type=script&lang=js&"
export * from "./OrganizationChartLevelForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports